import { API_URLS } from '../../../routes/urls';
import { apiSlice } from '../../apiSlice';
import { Ad } from '../../../types/ads';

const adsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    activeAds: builder.query<Ad[], string>({
      query: (host_page_link) => ({
        url: API_URLS.activeAds,
        params: { host_page_link },
      }),
    }),
  }),
});

export const { useActiveAdsQuery } = adsApi;
